
import props from './props'
export default {
  props,
  data() {
    return {
      value: '',
    }
  },
  mounted() {
    const gclid = JSON.parse(localStorage.getItem('gclid'))
    const isGclidValid = new Date().getTime() < gclid?.expiryDate
    if (!gclid || !isGclidValid || !gclid.value) return
    this.value = gclid.value
  },
}
